import { useI18n } from '@change-corgi/core-react/i18n';

import { useCanSavePaymentMethod } from '#src/app/shared/hooks/payments';

import { useMoreWaysExpanded, usePromoteFormData, usePromoteFormState } from '../../../../formContext';

type Result = ModelHookResult<
	{
		displayed: boolean;
		shouldSavePaymentMethod: boolean;
		label: string;
	},
	{ setShouldSavePaymentMethod: (shouldSavePaymentMethod: boolean) => void }
>;

export function useShouldSavePaymentMethodInput(): Result {
	const [
		{
			paymentMethodSaveOptions: { shouldSavePaymentMethod },
		},
		{ setShouldSavePaymentMethod },
	] = usePromoteFormState();
	const moreWaysExpanded = useMoreWaysExpanded();

	const {
		featureConfigs: { doubleOptinEnabledNewUser },
	} = usePromoteFormData();
	const canSavePaymentMethod = useCanSavePaymentMethod(doubleOptinEnabledNewUser);

	const { translate } = useI18n();

	return {
		data: {
			displayed: canSavePaymentMethod && moreWaysExpanded,
			shouldSavePaymentMethod,
			label: translate('corgi.co.promote.save_payment_info'),
		},
		actions: {
			setShouldSavePaymentMethod,
		},
	};
}
